<script setup lang="ts">
import { getApiAuctionDetailQueryKey, useApiAuctionDetail, useApiTrackSaleView } from '~/apiClient';
import { AUCTION_DETAIL_QUERY_KEY_PREFIX } from '~/constants/queryKeyPrefix';

definePageMeta({
    key: route => `auction-detail-static-${route.params.slug}`, // Prevent full page re-rendering on locale change
});

// COMPOSABLES
const route = useRoute();
const { id } = useSdpParams();
const { trackViewSale } = useTracking();
const { locale } = useTypedI18n();
const { mutate: trackSaleView } = useApiTrackSaleView();

// DATA
const {
    data: sale,
    error,
    isError,
    suspense,
    refetch,
} = useApiAuctionDetail(id, {
    query: {
        queryKey: [AUCTION_DETAIL_QUERY_KEY_PREFIX, ...getApiAuctionDetailQueryKey(id)],
    },
});

// Perform await only if the id is correct resolved to the path
!!id.value && (await suspense());

useSdpParamsChecker(sale, error, isError);

// LIFECYCLE
onMounted(() => {
    if (sale.value) {
        trackViewSale(sale.value);
        trackSaleView({
            data: {
                auctionId: sale.value.id,
                language: localeToLanguage(locale.value),
                urlPath: route.fullPath,
            },
        });
    }
});
</script>
<template>
    <Sdp v-if="sale" :sale="sale" @refetch="refetch" />
</template>
